export function generateSlug(id: string): string {
  if (!id) return '';

  try {
    const { pathname } = new URL(id, 'https://placeholder.local');
    const segments = pathname.replace(/\/$/, '').split('/').filter(Boolean);
    const lastSegment = segments.at(-1) ?? '';
    const penultimate = segments.at(-2);

    if (penultimate && /^\d{4}$/.test(penultimate)) {
      return `${penultimate}-${lastSegment}`;
    }

    return lastSegment;
  } catch {
    return '';
  }
}
